import { observable, action, computed, makeObservable } from 'mobx';
import _ from 'lodash';

export class ParentGuidance {
  constructor(data, root) {
    this._root = root;
    this.id = data.id;
    this.title = data.title;
    this.activity_title = data.activity_title;
    this.description = data.description;
    this.guidance = data.guidance;
    this.time_commitment = data.time_commitment;
    this.grade_band = data.grade_band;
    this.grade = data.grade;
    this.video_url = data.video_url;
    this.video_url_thumbnail = data.video_url_thumbnail;
    this.image_file_name = data.image_file_name;
    this.activity_image_file_name = data.activity_image_file_name;
    this.skill_id = data.skill_id;
    this.power_skill_level_id = data.power_skill_level_id;
    this.power_skill_parent_curriculum_id = data.power_skill_parent_curriculum_id;
    this.url_resources = data.url_resources;
  }

  get type() {
    return this.skill_id ? 'academic' : 'power';
  }

  get skillLevel() {
    return this.type === 'power' ? this._root.PowerSkillStore.findLevel(this.power_skill_level_id) : this._root.SkillStore.find(this.skill_id);
  }

  get practiceCount() {
    return this._root.ParentAttestationStore.attestationsForGuidance(this.id).length;
  }

  get hasCompletion() {
    return this.practiceCount > 0;
  }

  practiceCountForPotentialChild(potentialChildId) {
    return this._root.ParentAttestationStore.attestationsFor(potentialChildId, this.id).length;
  }

  get gradeLevel() {
    return this.skillLevel.gradeLevel;
  }

  get thumbnailUrl() {
    return this.video_url_thumbnail || this.activity_image_file_name;
  }
}

export default class ParentGuidanceStore {
  constructor(root) {
    makeObservable(this, {
      data: observable,
      add: action,
      addMany: action,
      remove: action,
      all: computed,
      reset: action,
    })

    this.root = root;
  }

  data = new Map();

  add = (data) => {
    const guidance = new ParentGuidance(data, this.root);
    this.data.set(guidance.id, guidance);
  }

  addMany = (datas) => {
    const merge = new Map();
    datas.forEach(data => {
      const guidance = new ParentGuidance(data, this.root);
      merge.set(guidance.id, guidance);
    })
    this.data.merge(merge)
  }

  remove = (id) => {
    if (id && this.data.has(id)) this.data.delete(id);
  }

  find(id) {
    return this.data.get(id);
  }

  get all() {
    return Array.from(this.data.values());
  }

  reset = () => {
    this.data.clear();
  }
}
